import React from 'react';
import PropTypes from 'prop-types';
import { useSnackbarContext } from 'Context/SnackbarContext';
import fr from 'facet-rest';
import { noop } from 'Helpers/PropTypes';
import { ViewableListItem } from 'Organisms/ViewableListItem/ViewableListItem';

const AttachmentListItem = ({
  attachment, icon, confirmOnDelete, onDelete, onView,
}) => {
  const { displayErrorMessage } = useSnackbarContext();

  const handleDelete = async () => {
    try {
      if (attachment.link('self')) {
        await attachment.link('self').delete();
        await onDelete(attachment);
      }
    } catch (e) {
      displayErrorMessage(e, e.errors[0]?.detail || 'Unable to delete the document');
    }
  };

  return (
    <ViewableListItem
      attachment={attachment}
      itemText={attachment.attr('name')}
      icon={icon}
      confirmOnDelete={confirmOnDelete}
      onDelete={handleDelete}
      onView={onView}
    />
  );
};

AttachmentListItem.defaultProps = {
  icon: '',
  onDelete: noop,
  onView: noop,
  confirmOnDelete: false,
};

AttachmentListItem.propTypes = {
  attachment: PropTypes.instanceOf(fr.Resource).isRequired,
  icon: PropTypes.string,
  onDelete: PropTypes.func,
  onView: PropTypes.func,
  confirmOnDelete: PropTypes.bool,
};

export { AttachmentListItem };
